import { useState } from "react";
import { Link } from "react-router-dom";

import { api } from "@/api";
import { formatError } from "@/auth";
import { BUILDING_TYPES } from "@/pages/siteContent";
import { Arrow, Check, Clock } from "@/components/landing/icons";
import { MicTextarea } from "@/components/landing/MicTextarea";

export function LandingForm({ source = "accueil", defaultBuilding = "" }) {
  const [form, setForm] = useState({ name: "", organisation: "", email: "", phone: "", building_type: defaultBuilding, message: "", consent: false });
  const [state, setState] = useState({ busy: false, done: false, error: "" });
  const [audio, setAudio] = useState(null);
  const up = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, done: false, error: "" });
    try {
      const { data } = await api.post("/public/contact", { ...form, source });
      const blob = audio ? await audio() : null;
      if (blob?.size && data.id) {
        const body = new FormData();
        body.append("file", blob, `message.${blob.type.includes("mp4") ? "mp4" : blob.type.includes("ogg") ? "ogg" : "webm"}`);
        await api.post(`/public/contact/${data.id}/audio`, body, { params: { token: data.audio_token }, timeout: 120000 }).catch(() => {});
      }
      setState({ busy: false, done: true, error: "" }); } catch (err) { setState({ busy: false, done: false, error: formatError(err.response?.data?.detail) }); }
  };
  if (state.done) {
    return <div className="lp-done" data-testid="contact-success"><Check /><p>Merci ! Votre demande est bien reçue, un conseiller Airthermo vous recontacte rapidement.</p></div>;
  }
  return (
    <form className="lp-form" onSubmit={submit} data-testid="contact-form">
      <input placeholder="Nom et prénom *" value={form.name} onChange={up("name")} required data-testid="contact-name" />
      <input placeholder="Téléphone" value={form.phone} onChange={up("phone")} data-testid="contact-phone" />
      <input type="email" placeholder="E-mail *" value={form.email} onChange={up("email")} required data-testid="contact-email" />
      <select value={form.building_type} onChange={up("building_type")} data-testid="contact-building">
        <option value="">Type de bâtiment</option>
        {BUILDING_TYPES.map((t) => <option key={t}>{t}</option>)}
      </select>
      <MicTextarea value={form.message} onChange={(message) => setForm((f) => ({ ...f, message }))} onAudio={setAudio} />
      <label className="lp-consent lp-full" data-testid="contact-consent-label"><input type="checkbox" checked={form.consent} onChange={(e) => setForm((f) => ({ ...f, consent: e.target.checked }))} required data-testid="contact-consent" /><span>J'accepte d'être recontacté par Airthermo au sujet de mon projet. Voir la <Link to="/politique-de-confidentialite" target="_blank" data-testid="contact-privacy-link">politique de confidentialité</Link> *</span></label>
      {audio && <p className="lp-audio-ok lp-full" data-testid="contact-audio-ready"><Check />Message vocal enregistré, il sera joint à votre demande.</p>}
      {state.error && <p className="lp-error lp-full" data-testid="contact-error">{state.error}</p>}
      <button type="submit" className="lp-btn lp-full" disabled={state.busy} data-testid="contact-submit">{state.busy ? "Envoi…" : "Demander mon étude gratuite – 0 € de courtage"}<span className="lp-ico"><Arrow /></span></button>
      <p className="lp-legal lp-full"><span><Check />0 € de frais de courtage</span><span><Check />Sans engagement</span><span><Clock />Rappel rapide</span></p>
    </form>
  );
}
